import React from 'react'
import { translate } from 'react-i18next'
import PropTypes from 'prop-types'
import ZoneMap from './ZoneMap'

import './GardenersInfoText.css'

const GardenersInfoTextComponent = ({ t, city, cityDescriptionHtml, titleHtml, zipCodes, selectedPostalCode }) => {
  // For map display: geo.api.gouv.fr returns the same city polygon for all arrondissement codes
  // (75001-75020 all return Paris). Generic codes like 75000 return nothing.
  // So we pick the selected code if it works, otherwise fall back to the first valid one.
  var mapZipCodes = selectedPostalCode && !/000$/.test(selectedPostalCode)
    ? [selectedPostalCode]
    : (zipCodes && zipCodes.length > 0 ? [zipCodes.find(function (z) { return !/000$/.test(z) }) || zipCodes[0]] : zipCodes)

  return (
  <div>
    <div className="gardeners-listing__sep" />
    {/* Texte en dur (générique, toutes villes) */}
    <div className='offer-description'>
      <p className='jardiniers__current-text'>
        {t('common:gardenersInfoText:bestGardenersOfCity', { city })}
      </p>
      <h3 className='jardiniers__sndtitle'>
        {city
          ? t('common:gardenersInfoText:legalTitle1City', { city })
          : t('common:gardenersInfoText:legalTitle1')
        }
      </h3>
      <p className='jardiniers__current-text'>
        {t('common:gardenersInfoText:legalText1')}
      </p>
      <p className='jardiniers__current-text'>
        {t('common:gardenersInfoText:legalText2')}
      </p>
      <p className='jardiniers__current-text'>
        {t('common:gardenersInfoText:legalText3')}
      </p>
      <h3 className='jardiniers__sndtitle'>
        {t('common:gardenersInfoText:legalTitle1')}
      </h3>
      <p className='jardiniers__current-text'>
        {t('common:gardenersInfoText:legalText4City', { city })}
      </p>
      <h3 className='jardiniers__sndtitle'>
        {city
          ? t('common:gardenersInfoText:workTypesCity', { city })
          : t('common:gardenersInfoText:workTypes')
        }
      </h3>
      <ul className='jardiniers__secondtext-list'>
        <li>{t('common:gardenersInfoText:workType1')}</li>
        <li>{t('common:gardenersInfoText:workType2')}</li>
        <li>{t('common:gardenersInfoText:workType3')}</li>
        <li>{t('common:gardenersInfoText:workType4')}</li>
        <li>{t('common:gardenersInfoText:workType5')}</li>
        <li>{t('common:gardenersInfoText:workType6')}</li>
        <li>{t('common:gardenersInfoText:workType7')}</li>
        <li>{t('common:gardenersInfoText:workType8')}</li>
        <li>{t('common:gardenersInfoText:workType9')}</li>
        <li>{t('common:gardenersInfoText:workType10')}</li>
        <li>{t('common:gardenersInfoText:workType11')}</li>
        <li>{t('common:gardenersInfoText:workType12')}</li>
        <li>{t('common:gardenersInfoText:workType13')}</li>
        <li>{t('common:gardenersInfoText:workType14')}</li>
        <li>{t('common:gardenersInfoText:workType15')}</li>
        <li>{t('common:gardenersInfoText:workType16')}</li>
        <li>{t('common:gardenersInfoText:workType17')}</li>
      </ul>
    </div>

    {/* Carte zone entre les deux blocs de texte */}
    {zipCodes && zipCodes.length > 0 && (
      <div className='gardeners-listing__map-section'>
        <h3 className='gardeners-listing__map-title'>
          {'Zone couverte à ' + (city || '')}
        </h3>
        <div className='gardeners-listing__map'>
          <ZoneMap zipCodes={mapZipCodes} />
        </div>
        <div className='gardeners-listing__map-chips'>
          {zipCodes.map(function (zip, i) {
            return <span key={i} className={'gardeners-listing__map-chip' + (zip === selectedPostalCode ? ' gardeners-listing__map-chip--active' : '')}>{zip}</span>
          })}
        </div>
      </div>
    )}

    {/* Texte API (spécifique à la ville) */}
    {cityDescriptionHtml
      ? <div
          className='city-description'
          dangerouslySetInnerHTML={{ __html: cityDescriptionHtml }}
        />
      : <div className='city-description'>
          <h3 className='jardiniers__sndtitle'>
            {city
              ? t('common:gardenersInfoText:discoverOurGardenersCity', { city })
              : t('common:gardenersInfoText:discoverOurGardeners')
            }
          </h3>
          <p className='jardiniers__current-text'>
            {t('common:gardenersInfoText:qualityAssurance')}
          </p>
          <ul className='jardiniers__text-list'>
            <li>{t('common:gardenersInfoText:respect')}</li>
            <li>{t('common:gardenersInfoText:creativity')}</li>
            <li>{t('common:gardenersInfoText:proWork')}</li>
            <li>{t('common:gardenersInfoText:engaged')}</li>
          </ul>
        </div>
    }
  </div>
  )
}

GardenersInfoTextComponent.propTypes = {
  t: PropTypes.func,
  city: PropTypes.string,
  cityDescriptionHtml: PropTypes.string,
  titleHtml: PropTypes.string,
  metaDescription: PropTypes.string,
  metaTitle: PropTypes.string,
  zipCodes: PropTypes.array,
  selectedPostalCode: PropTypes.string
}

GardenersInfoTextComponent.defaultProps = {
  city: ''
}

export const GardenersInfoText = translate()(GardenersInfoTextComponent)



// WEBPACK FOOTER //
// ./src/components/gardeners/GardenersInfoText.js